import React, { useState, useEffect } from 'react';
import API from '../utils/apiCalling';
import Config from '../config/env'
import Loader from "../utils/loader";

const QcStartPage = (props) => {
  const api = new API
  const [loader, setLoader] = useState(false)
  const [responses, setResponses] = useState({});
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    status: "",
  });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const downloadExcel = async () => {
    console.log("Downloading Excel with filters:", filters);
    let data = {
      survey_id: props.match.params.id,
      startDate: filters.startDate,
      endDate: filters.endDate,
      status: filters.status
    };

    setLoader(true);

    try {
      let url = '/qcSurvey/DownloadQcExcelBySurveyId'

      const response = await fetch(`${Config.new.site_api}${url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        setLoader(false);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = `${filters.status} Survey Responses.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      } else {
        setLoader(false);
        console.error('Failed to download file');
      }
    } catch (error) {
      setLoader(false);
      console.error('Error:', error);
    }
  };


  const handleStartQC = (responseId) => {
    console.log('Starting QC for:', responseId);
    // You can redirect or trigger an API call here
  };
  useEffect(async () => {
    console.log(props, "props")
    setLoader(true)
    const result = await api.post(`${Config.new.site_api}/qcSurvey/qcDashboardCounts`, { survey_id: props.match.params.id });
    setLoader(false)
    if (result && result.code == 200) {
      setResponses(result.data)
    }

  }, [])
  return (<>{loader && <Loader />}
    {/* <div style={{ padding: '20px' }}>
      <h2>Response QC List</h2>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ccc' }}>Response ID</th>
            <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ccc' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {responses.map((id, index) => (
            <tr key={index}>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{id}</td>
              <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                <button onClick={() => handleStartQC(id)} style={{ padding: '6px 12px', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px' }}>
                  Start QC
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div> */}
    <section id="all-section" className="admin-header position-relative">

      <nav className="navbar navbar-expand-lg bg-white p-0 border border-bottom" style={{ height: "80px" }}>
        <div className="container-fluid ">
          <a className="navbar-brand1 logo-itemsw logoMain" target="break"><img src={"../images/new-logo.png"} alt="" style={{ height: "70px", margin: "5px" }} /></a>

        </div>

      </nav>
    </section>
    <div className="container mt-4">
      {/* Stats Boxes */}
      <div className="row text-center mb-4">
        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <h5>Total Survey</h5>
            <h3>{responses?.totalSurveyCount || 0}</h3>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <h5>Total QC</h5>
            <h3>{responses?.totalQc || 0}</h3>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <h5>QC Pending</h5>
            <h3>{responses?.QcPending || 0}</h3>
          </div>
        </div>


        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <h5>QC Rejected</h5>
            <h3>{responses?.QcRejeced || 0}</h3>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="card p-4 shadow-sm">
        <h5 className="mb-3">Filter & Download</h5>
        <div className="row g-3">
          <div className="col-md-3">
            <label>Start Date</label>
            <input
              type="date"
              name="startDate"
              className="form-control"
              value={filters.startDate}
              onChange={handleFilterChange}
            />
          </div>
          <div className="col-md-3">
            <label>End Date</label>
            <input
              type="date"
              name="endDate"
              className="form-control"
              value={filters.endDate}
              onChange={handleFilterChange}
            />
          </div>
          <div className="col-md-3">
            <label>Status</label>
            <select
              name="status"
              className="form-control"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option hidden>Select Status</option>
              <option value="allField">All Field Data</option>
              <option value="AllQc"> All QC Data</option>
              <option value="pending">QC Pending</option>
              <option value="rejected">QC Rejected</option>
            </select>
          </div>
          <div className="col-md-3 d-flex align-items-end">
            <button
              className="btn btn-primary w-100"
              onClick={downloadExcel}
            >
              Download Excel
            </button>
          </div>
        </div>
      </div>
    </div>

  </>
  );
};

export default QcStartPage;
